
import {timer as observableTimer,  Observable } from 'rxjs';
import { BaseTracking } from "./base-tracking";
import { Config } from "app/core/vo/config";
import { Logger } from "../../helpers/Logger";
import { UtilityScripts } from "../../helpers/utility-scripts";

export class Scorm extends BaseTracking {
	private alwaysCheckError: boolean;
	private scormExitToEmpty: boolean;
	private commStatus: string;
	private API: Object;
	private apiTimer: any;
	private intCurrentRetryCount: number;
	private lmsfinish_sent: boolean;
	private readonly RETRY_COUNT: number = 10;
	private trackMode: string;

	protected initProperties(data) {
		super.initProperties(data);
		this.alwaysCheckError = data.alwaysCheckError;
		this.scormExitToEmpty = data.scormExitToEmpty;
		this.commStatus = "";
		this.lmsfinish_sent = false;
		this.intCurrentRetryCount = 0;
		this.trackMode = data.trackMode;
	}
	public doInitialize() {
		this.commStatus = "initializing";
		Logger.log(2, "SCORMFLOW:initialize:1 Finding API. API is currently ");
		if (!this.API) {
			this.findAPI();
			if (!this.API) {
				this.apiTimer = observableTimer(2000);
				this.apiTimer.subscribe((t) => {
					this.handleRetryInitialize(event);
				});
			}
		}
		if (this.API) {
			//API != null;
			Logger.log(2, "SCORMFLOW:initialize:3 : SCORM API: " + this.API);
			this.disposeApiTimer();
			this.commStatus = "loading";
			Logger.log(2, "SCORMFLOW:initialize:4: Calling JSAPI.LMSInitalize");
			let success = (window as any)["JSAPI"].LMSInitialize(""); //ExternalInterface.call( "JSAPI.LMSInitialize", "" );

			if (success === true || success == "true") {
				//success = true;
				Logger.log(2, "SCORMFLOW:initialize:5Y: SCORM: Success!");
				this.setTrackingData();
				this.notifyInitialize();
			} else {
				Logger.log(
					2,
					"SCORMFLOW:initialize:5N: SCORM API Initialize: " + success
				);
			}
		}
	}
	private findAPI() {
		Logger.log(2, "SCORM: Calling findAPI()");
		this.API = (window as any).findAPI(); //ExternalInterface.call("findAPI");
		Logger.log(2, "SCORM: JS returned " + this.API);
	}
	private handleRetryInitialize(evt) {
		this.disposeApiTimer();

		this.intCurrentRetryCount++;
		if (this.intCurrentRetryCount > this.RETRY_COUNT) {
			Logger.log(
				2,
				"SCORMFLOW:retryInitialize:2Y: ERROR: SCORM API not found."
			);
			Logger.log(
				0,
				"<b>Communications Failure</b><br/><br/>API not found.<br/><br/>The course was unable to communicate with the Learning Management System.  " +
					"Please close all browser windows and try again.<br/><br/>  If the problem persists, please contact your help desk."
			);
		} else {
			Logger.log(2, "SCORMFLOW:retryInitialize:2N: Retrying Initialize()");
			this.doInitialize();
		}
	}
	private disposeApiTimer() {
		if (this.apiTimer) {
			this.apiTimer.unsubscribe();
			this.apiTimer = null;
		}
	}
	private setTrackingData() {
		this.setStudentData();
		this.setLessonData();
		this.setTimeData();
		this.finishInitialization();
	}
	private setStudentData() {
		this.trackingVO.studentName = this.doGetValue("cmi.core.student_name");
		this.trackingVO.studentId = this.doGetValue("cmi.core.student_id");
	}
	protected setLessonData() {
		this.trackingVO.lessonLocation = this.resolve_lesson_location(
			this.doGetValue("cmi.core.lesson_location")
		);
		//this.trackingVO.lessonLocation = "english,low,module_news,scene_news,news_01anch";
		Logger.log(
			2,
			"SCORMFLOW:initialize:6: SCORM: lessonLocation: " +
				this.trackingVO.lessonLocation
		);
		this.trackingVO.lessonStatus = this.doGetValue("cmi.core.lesson_status");
		Logger.log(
			2,
			"SCORMFLOW:initialize:6: SCORM: lessonStatus: " +
				this.trackingVO.lessonStatus
		);
		this.trackingVO.lessonStatus = this.trackingVO.lessonStatus
			.toLowerCase()
			.substring(0, 1);
		//this.trackingVO.lessonStatus  = "p";
		if (this.trackingVO.lessonStatus === "0")
			this.trackingVO.lessonStatus = "n";

		if (
			this.trackingVO.lessonStatus !== "c" &&
			this.trackingVO.lessonStatus !== "i" &&
			this.trackingVO.lessonStatus !== "p" &&
			this.trackingVO.lessonStatus !== "n"
		) {
			Logger.log(
				2,
				"SCORMFLOW:initialize:8Y: SCORM: invalid lessonStatus. Reset lessonStatus to i"
			);
			this.trackingVO.lessonStatus = "i";
		}
		this.strOrigStatus = this.trackingVO.lessonStatus;
		let suspendData: string = this.resolve_suspend_data(
			this.doGetValue("cmi.suspend_data")
		);
		//suspendData = "bookmark%3Ec%2C5%2Cscene_news%3Bc%2C1%2Cscene_harr%3Bc%2C2%2Cscene_anti-mon-laund%3Bc%2C3%2Cscene_codeinaction%3Bi%2C2%2Cscene_concl%3B%26completion_date%3E1325588842235%26elt_total_time%3E0%3A0%3A58.54%26";
		//suspendData = "bookmark>c,5,scene_news;c,1,scene_harr;c,2,scene_anti-mon-laund;c,3,scene_codeinaction;i,2,scene_concl;&completion_date>1325588842235&elt_total_time>0:0:58.54&";
		this.parseSuspenddata(suspendData);
		//	trace("suspendData="+suspendData);
		Logger.log(
			2,
			"SCORMFLOW:initialize:9: SCORM: bookmark: " + this.trackingVO.bookmark
		);
		Logger.log(
			2,
			"SCORMFLOW:initialize:9: SCORM: completion_date: " +
				this.trackingVO.completionDate
		);
	}
	private setTimeData() {
		//Logger.log("set time data >>>"+this.trackingVO.totalTime+":")

		if (
			this.trackingVO.totalTime == null ||
			this.trackingVO.totalTime === "" ||
			this.trackingVO.totalTime === undefined
		) {
			Logger.log(
				2,
				"SCORMFLOW:initialize:11Y: SCORM: Invalid time. Reset time to 0000:00:00.00"
			);
			this.trackingVO.totalTime = "0000:00:00.00";
		}
		if (this.trackingVO.totalTime.indexOf(":") < 0) {
			Logger.log(2, "SCORMFLOW:initialize:12Y: SCORM: Time in seconds.");
			//Special case for LMS which incorrectly returns time in seconds, contrary to the SCORM spec:
			let hours: number = Math.floor(Number(this.trackingVO.totalTime) / 3600);
			let minutes: number = (Number(this.trackingVO.totalTime) % 3600) / 60;
			let seconds: number = Number(this.trackingVO.totalTime) % 60;
			this.trackingVO.totalTime =
				hours.toString() +
				":" +
				minutes.toString() +
				":" +
				seconds.toString() +
				".00";
		}
		Logger.log(
			2,
			"SCORMFLOW:initialize:13: SCORM: total_time: " + this.trackingVO.totalTime
		);
	}
	private finishInitialization() {
		let credit: string = String(this.doGetValue("cmi.core.credit"));
		Logger.log(2, "SCORMFLOW:initialize:13: SCORM: credit: " + credit);
		//if ( credit != 'credit' ) _root.opProfile = 'demo';
		this.commStatus = "ready";

		// In JS, loadVar would be called here...

		if (this.strOrigStatus === this.completedVal && this.quietComplete) {
			Logger.log(
				2,
				"SCORMFLOW:initialize:14Y: SCORM: Course was completed when launched - disabling further communication"
			);
			this.doFinish();
		} else if (this.strOrigStatus !== this.completedVal) {
			this.doSetValue("cmi.core.lesson_status", "incomplete");
			Logger.log(
				2,
				"SCORMFLOW:initialize:15Y: SCORM: Set cmi.core.lessonStatus to incomplete"
			);
			this.forceSave();
		}
		(window as any).lockAPI();
		//ExternalInterface.call( "lockAPI" );
	}
	public doGetValue(prop: string): string {
		return (window as any)["JSAPI"].LMSGetValue(prop); //String(ExternalInterface.call("JSAPI.LMSGetValue",prop));
	}
	public doSetValue(prop, value) {
		let retValue: boolean;
		let success: Object = (window as any)["JSAPI"].LMSSetValue(prop, value); //ExternalInterface.call("JSAPI.LMSSetValue",prop,value);
		if (success === "true" || success === true) {
			retValue = true;
			if (this.alwaysCheckError) {
				this.showErrors();
			}
		} else {
			retValue = false;
			this.showErrors();
		}
		//return retValue;
	}
	public doCommit(): boolean {
		Logger.log(2, "SCORMFLOW:commit:1: SCORM: commit()");
		Logger.log(
			2,
			"SCORMFLOW:commit:1: SCORM: lesson_status: " +
				this.trackingVO.lessonStatus
		);
		Logger.log(2, "SCORMFLOW:commit:1: SCORM: commStatus: " + this.commStatus);
		Logger.log(
			4,
			"SCORMFLOW:commit:1: SCORM: timeSaveMode: " + this.timeSaveMode
		);
		Logger.log(
			4,
			"SCORMFLOW:commit:1: SCORM: timeSingleSend: " + this.timeSingleSend
		);

		//let strScoreMode;
		if (this.commStatus === "ready") {
			//Logger.log( 'SCORMFLOW:commit:2Y: SCORM: this.lmsfinish_sent: ' + this.lmsfinish_sent );
			if (!this.lmsfinish_sent) {
				Logger.log(
					2,
					"SCORMFLOW:commit:3Y: SCORM: Saving Bookmark...(scormCommit)"
				);
				Logger.log(
					2,
					"SCORMFLOW:commit:5: SCORM: orig_status: " +
						this.strOrigStatus +
						" completedVal: " +
						this.completedVal
				);
				if (this.strOrigStatus === this.completedVal) {
					this.trackingVO.lessonStatus = this.completedVal;
				} else {
					let scormstatus: string;
					if (this.trackingVO.lessonStatus === "i") {
						scormstatus = "incomplete";
					} else if (this.trackingVO.lessonStatus === this.completedVal) {
						if (this.trackingVO.lessonStatus === "p") {
							scormstatus = "passed";
						} else if (this.trackingVO.lessonStatus === "c") {
							scormstatus = "completed";
						}

						if (this.timeSingleSend) {
							this.setSessionTime();
						}
					} else {
						Logger.log(
							0,
							"SCORMFLOW:commit:8N: ERROR: CompletedVal of " +
								this.completedVal +
								" does not have a proper SCORM keyword (such as incomplete, passed, completed)."
						);
					}
					// added by sreejesh incomplete status is set at initialize do dont set it here.
					if (scormstatus !== "incomplete") {
						Logger.log(2, "SCORMFLOW:commit:12: SCORM: Status: " + scormstatus);
						this.doSetValue("cmi.core.lesson_status", scormstatus);
					}
					//
					if (this.trackingVO.score < 50) {
						switch (Number(this.scoreMode)) {
							case 0:
								Logger.log(4, "SCORMFLOW: ScoreMode 0");
								break;
							case 1:
								Logger.log(4, "SCORMFLOW: ScoreMode 1");
								break;
							case 2:
								Logger.log(4, "SCORMFLOW: ScoreMode 2");
								this.trackingVO.score = 0; //scoreMode 2 reports a value for score
								this.doSetValue(
									"cmi.core.score.raw",
									String(
										this.trackingVO.score &&
											this.trackingVO.lessonStatus === this.completedVal
											? this.trackingVO.score
											: this.trackingVO.score
									)
								);
								break;
							case 3:
								Logger.log(4, "SCORMFLOW: ScoreMode 3");
								this.trackingVO.score = null; //scoreMode 3 sends null if score is not 100
								this.doSetValue(
									"cmi.core.score.raw",
									String(this.trackingVO.score)
								);

								break;
						}
					} else {
						if (Number(this.scoreMode) > 0) {
							//&& this.trackingVO.score != null )
							//scoreMode 1 only sends score on completion (100)
							Logger.log(
								4,
								"SCORMFLOW:commit:15N: SCORM: scoreMode = " +
									this.scoreMode +
									", setting score.raw: " +
									this.trackingVO.score
							);
							//this.doSetValue("cmi.core.score.raw",String((this.trackingVO.score && this.trackingVO.lessonStatus === this.completedVal) ? this.trackingVO.score : this.trackingVO.score));
							this.doSetValue(
								"cmi.core.score.raw",
								String(this.trackingVO.score)
							);
						}
					}

					Logger.log(
						2,
						"SCORMFLOW:commit:16N: SCORM: timeSingleSend is set to : " +
							this.timeSingleSend
					);
					if (!this.timeSingleSend) {
						this.setSessionTime();
					}

					let suspend_data: string = this.formSuspendData();
					Logger.log(
						2,
						"SCORMFLOW:commit:17: SCORM: suspend_data: " + suspend_data
					);
					if (suspend_data !== "" && suspend_data !== null) {
						this.doSetValue("cmi.suspend_data", suspend_data);
					}
					if (this.trackingVO.lessonLocation != null) {
						Logger.log(
							2,
							"SCORMFLOW:commit:18Y: SCORM: Location: " +
								this.trackingVO.lessonLocation
						);
						this.doSetValue(
							"cmi.core.lesson_location",
							this.trackingVO.lessonLocation
						);
					}

					Logger.log(2, "SCORMFLOW:commit:19: calling forceSave()");
					this.forceSave();
				}
			} else {
				Logger.log(
					2,
					"SCORMFLOW:commit:2N: Course has been completed and quietComplete is enabled; nothing to do here."
				);
			}
		}
		return true;
	}
	public setSessionTime() {
		switch (this.timeSaveMode) {
			case 0:
				break;
			case 1:
				Logger.log(
					2,
					"SCORMFLOW:commit:16Y:1: SCORM: Saving session_time: " +
						this.trackingVO.sessionTime
				);
				this.doSetValue("cmi.core.session_time", this.trackingVO.sessionTime);
				break;

			case 2:
				Logger.log(
					2,
					"SCORMFLOW:commit:16Y:2: SCORM: Saving total time to session_time: " +
						this.trackingVO.totalTime
				);
				//this.doSetValue("cmi.core.session_time",this.trackingVO.totalTime );
				this.doSetValue("cmi.core.session_time", this.trackingVO.sessionTime);
				break;

			case 3:
				this.doSetValue("cmi.core.session_time", "00:00:00");
				break;
		}
	}
	protected forceSave() {
		if (this.lmsfinish_sent === false) {
			Logger.log(2, "SCORMFLOW:forceSave:1Y: SCORM: Calling LMSCommit...");
			let succ = (window as any)["JSAPI"].LMSCommit(""); //ExternalInterface.call( "JSAPI.LMSCommit", "" );
			Logger.log(
				2,
				"SCORMFLOW:forceSave:1Y: SCORM: Commit Success: " +
					succ +
					", quietComplete is " +
					this.quietComplete
			);

			if (
				(succ !== "true" && this.showErrors() === false) ||
				(this.alwaysCheckError && this.showErrors() === false)
			) {
				Logger.log(2, "SCORMFLOW:forceSave:2Y: SCORM: Checking Commit Error");
				//showErrors();
			} else {
				//dispatchEvent( { type:'saveSuccess', target:this } );
				if (
					this.trackingVO.lessonStatus === this.completedVal &&
					this.quietComplete
				) {
					//do lms finish to prevent user from losing tracking data.
					Logger.log(
						2,
						"SCORMFLOW:forceSave:3Y: SCORM: Course Completed ..calling finish()"
					);
					this.doFinish();
				}
			}
		}
	}
	public doFinish(): any {
		if (this.lmsfinish_sent === false) {
			if (this.scormExitToEmpty) {
				Logger.log(4, "SCORMFLOW:finish:1: SCORM: Sending Exit=''");
				if(!this.terminateSingleSend)
					this.doSetValue("cmi.core.exit", "");
			} else {
				Logger.log(4, "SCORMFLOW:finish:1: SCORM: Sending Exit='suspend'");
				if(!this.terminateSingleSend)
					this.doSetValue("cmi.core.exit", "suspend");
			}
			this.lmsfinish_sent = true;
		}
		return true;
	}
	public async lmsFinish() {
 		if(this.terminateSingleSend)
			await this.doSetValue("cmi.exit","suspend");
		return (window as any).handleFinish();
	}
	private parseSuspenddata(rawData: string) {
		//Logger.log( 4, 'SCORMFLOW :raw suspend data from LMS: ' , rawData, ' : escapeCount : ' + this.escapeCount);
		rawData = UtilityScripts.dataEscapeUnescape(
			rawData,
			"unescape",
			this.escapeCount
		);
		let lines: Array<string> = rawData.split("&");
		for (let l in lines) {
			if (lines[l].indexOf(">") > 0) {
				let assigns: Array<string> = lines[l].split(">");
				//Logger.log(l,lines[l],assigns,Number(assigns[1]),parseInt(assigns[1]))
				if (assigns[0] === "score") {
					this.trackingVO.score = parseInt(assigns[1]);
				} else if (assigns[0] === "geolocation") {
					this.trackingVO.geoLocation = assigns[1];
				} else {
					this.trackingVO[assigns[0]] = assigns[1];
				}
				//Logger.log( 4, 'this.trackingVO.' , assigns[ 0 ] , ' = ' , assigns[ 1 ] );
			}
		}

		/* ------- Below is the fallback code in case the LMS does not returns a proper value for cmi.total_time/cmi.core.total_time --------------*/
		let cmi_total_time =
			this.trackMode == "scorm"
				? this.doGetValue("cmi.core.total_time")
				: this.doGetValue("cmi.total_time");
		if (
			rawData != "" &&
			rawData != "undefined" &&
			rawData != undefined &&
			rawData != null
		) {
			if (
				cmi_total_time != "" &&
				cmi_total_time != undefined &&
				cmi_total_time != null
			) {
				this.trackingVO["elt_total_time"] =
					this.trackMode == "scorm"
						? UtilityScripts.resolveTime(cmi_total_time.split(".")[0])
						: UtilityScripts.convertPTHMStoHHMMSS(cmi_total_time);
			}
		}
		/* -----------------------------------------------------------------------------------------------------------------------------------------*/
	}
	private formSuspendData() {
		let suspend_data: string = "bookmark>" + this.trackingVO["bookmark"] + "&";
		suspend_data +=
			"completion_date>" + this.trackingVO["completionDate"] + "&";
		suspend_data +=
			"elt_total_time>" +
			UtilityScripts.resolveTime(this.trackingVO["totalTime"]); // + '&otherstuff>' + otherstuff
		// Save other suspend_data fields
		if (this.trackingVO.geoLocation != null) {
			suspend_data += "&geolocation>" + this.trackingVO.geoLocation;
		}
		if (this.trackingVO.score > 0) {
			suspend_data += "&score>" + this.trackingVO.score;
		}
		if(this.trackingVO.rubricStatus) {
            suspend_data += '&rubricStatus>' + this.trackingVO.rubricStatus;
        }
		// Note browser information
		suspend_data += UtilityScripts.browserAndSystemInfo();
		suspend_data += "&complianceTypeID>"+this.trackingVO.complianceTypeID;
		suspend_data += "&complianceTypeName>"+this.trackingVO.complianceTypeName;
		// ------------------------------------------------
		suspend_data = UtilityScripts.dataEscapeUnescape(
			suspend_data,
			"escape",
			this.escapeCount
		); // this code line was commented in earlier version
		Logger.log(
			4,
			"suspend_data =============================================================" +
				suspend_data
		);
		console.log("formSuspendData = " + suspend_data);
		return suspend_data;
	}
	private showErrors() {
		Logger.log(2, "SCORMFLOW:showErrors:1: SCORM: showErrors()");
		// Return error message (if any)
		let error_code = (window as any)["JSAPI"].LMSGetLastError(); //String( ExternalInterface.call( "JSAPI.LMSGetLastError" ) );
		if (error_code !== "0") {
			let error_str = (window as any)["JSAPI"].LMSGetErrorString(error_code); //String( ExternalInterface.call( "JSAPI.LMSGetErrorString", error_code ));
			let error_desc = (window as any)["JSAPI"].LMSGetDiagnostic(error_code); //String( ExternalInterface.call( "JSAPI.LMSGetDiagnostic", error_code ));
			//Logger.log( 0, "SCORMFLOW:showErrors:2Y: SCORM: Failure! Error Code: " + error_code);
			//Logger.log( 0, "SCORMFLOW:showErrors:2Y: SCORM: Error String: " + error_str);
			//Logger.log( 0, "SCORMFLOW:showErrors:2Y: SCORM: Error Diagnostic: " + error_desc );
			//Add text to LMS message
			if (error_str === "" || error_str == null || error_str === "undefined") {
				error_str = "Bookmarking error!";
			} else {
				error_str = "Bookmarking error:\n" + error_str;
			}
			if (
				error_desc === "" ||
				error_desc == null ||
				error_desc === "undefined"
			) {
				error_desc = "The course was unable to save or retrieve your progress.";
			} else {
				error_desc = "The LMS returned an error:\n" + error_str;
			}
			Logger.log(
				2,
				"SCORMFLOW:showErrors:5: Communication Failure. stop course."
			);
			error_desc +=
				"\nPlease close all browser windows and retry.Contact your help desk if the problem persists.";
			Logger.log(
				2,
				"<b>Communication Failure<b><br/><br/>" +
					error_desc +
					"<br/><br/>LMS Error Code: " +
					error_code
			);
			//EventManager.dispatchEvent(new AppEvent(AppEvent.TOAST,{header:"Communication Failure",body:error_desc,footer:error_code}));

			return false;
		}
		return true;
	}
}
